"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Regex = void 0;
exports.Regex = {
    UINFIN: /^[STFGM]\d{7}[A-Z]$/,
    NRIC_FIRST_CHAR: /^[ST]/,
    FIN_FIRST_CHAR: /^[FGM]/,
    NAME_CHARS: /^[A-Za-z\s\-/,'.@()]*$/,
    JAWI_CHARS: /^[\u0621-\u063a\u0640-\u064a\u0686\u06a0\u06a4\u06ac\u06af\u06bd\u06cf\ufef5\ufef7\ufef9\ufefb\u0020\u0672\u0673\u0698\u06a9\u06d1\u0762\u202b\u202c]*$/u,
    TAMIL_CHARS: /^[\u0b83-\u0bb5\u0bb7-\u0bcf\u0020]*$/u,
    CHINESE_CHARS: /^[\u{4e00}-\u{9fa5}\u{3400}-\u{4dbf}\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81d}]*$/u,
    ADDRESS: /^(?:(?!\|).)*$/,
    LOCAL_POSTAL_CODE: /^\d+$/,
    BANK_BRANCH_NUMBER: /^[0-9]{3}$/,
};
//# sourceMappingURL=regex.js.map